import { VerboseLogEntry } from '../../models/chat';
import { IconX } from '../Icons';

interface VerboseDrawerProps {
  open: boolean;
  onClose: () => void;
  logs: VerboseLogEntry[];
}

const LEVEL_COLORS: Record<string, string> = {
  Verbose: 'var(--text-5)',
  Debug: 'var(--text-2)',
  Information: 'var(--text)',
  Warning: 'var(--warn)',
  Error: 'var(--accent)',
  Fatal: 'var(--accent)',
};

export default function VerboseDrawer({ open, onClose, logs }: VerboseDrawerProps) {
  if (!open) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 70 }}>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'rgba(0,0,0,0.5)',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
          animation: 'fadeIn 0.15s ease-out',
        }}
        onClick={onClose}
        aria-hidden
      />
      <div
        className="card"
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          height: '100%',
          width: '100%',
          maxWidth: 480,
          background: 'var(--surface)',
          borderRadius: 0,
          borderLeft: '1px solid var(--line)',
          borderTop: 'none',
          borderRight: 'none',
          borderBottom: 'none',
          display: 'flex',
          flexDirection: 'column',
          animation: 'slideUp 0.18s ease-out',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '14px 20px',
            borderBottom: '1px solid var(--line)',
          }}
        >
          <div>
            <div className="eyebrow" style={{ marginBottom: 2 }}>Pipeline</div>
            <div className="display" style={{ fontSize: 16 }}>Detail log</div>
          </div>
          <button type="button" onClick={onClose} className="btn ghost sm icon">
            <IconX />
          </button>
        </div>
        <div
          className="scroll-thin"
          style={{
            flex: 1,
            overflow: 'auto',
            padding: '14px 20px',
            fontFamily: 'var(--font-mono)',
            fontSize: 12,
          }}
        >
          {logs.length === 0 ? (
            <div className="muted" style={{ textAlign: 'center', paddingTop: 32, fontFamily: 'var(--font-sans)' }}>
              No detail events yet.
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {logs.map((entry, idx) => (
                <div key={idx} style={{ display: 'flex', gap: 8 }}>
                  <span style={{ color: 'var(--text-6)', flex: 'none' }}>
                    {new Date(entry.timestamp).toLocaleTimeString()}
                  </span>
                  <span style={{ color: LEVEL_COLORS[entry.level] ?? 'var(--text-2)', flex: 'none' }}>
                    [{entry.level}]
                  </span>
                  <span style={{ color: 'var(--text-2)', wordBreak: 'break-word' }}>{entry.message}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
